import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { defineName } from '@szhsin/react-menu/dist/es/utils/utils';

// eslint-disable-next-line prefer-arrow-callback
const MenuButton = forwardRef(function MenuButton({
  size,
  shape,
  caret = true,
  isOpen,
  variant = 'transparent',
  children,
  disabled,
  frameless,
  className,
  ...restProps
}, ref) {
  const expandedClassName = typeof className === 'function' ? className({ open: isOpen }) : className;

  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={cx('hms-dropdown-btn', expandedClassName, {
        'hms-dropdown-btn--open': isOpen,
        'hms-dropdown-btn--disabled': disabled,
        'hms-dropdown-btn--frameless': frameless,
        'hms-dropdown-btn--with-caret': caret,
        [`hms-dropdown-btn--${size}`]: size,
        [`hms-dropdown-btn--${shape}`]: shape,
        [`hms-dropdown-btn--${variant}`]: variant,
      })}
      {...restProps}
      aria-haspopup
      aria-expanded={isOpen}
      aria-disabled={disabled || undefined}
    >
      {children}
    </button>
  );
});

MenuButton.propTypes = {
  size: T.oneOf(['lg', 'sm']),
  variant: T.oneOf(['transparent', 'light', 'primary']),
  shape: T.oneOf(['square']),
  caret: T.bool,
  isOpen: T.bool,
  children: T.node,
  disabled: T.bool,
  frameless: T.bool,
  className: T.oneOfType([T.string, T.func]),
};

export default defineName('MenuButton', MenuButton);
